import { createLocalStorage } from '@/utils/cache'

const tokenKey = 'token'

const ls = createLocalStorage()
// 设置token
export function setToken(value: any) {
  ls.set(tokenKey, value)
}
// 获取token
export function getToken() {
  return ls.get(tokenKey)
}
// 删除token
export function removeToken() {
  return ls.remove(tokenKey)
}
// 设置mdm系统token
export function setMdmToken(value: any) {
  ls.set('mdmToken', value)
}
// 获取mdm系统token
export function getMdmToken() {
  return ls.get('mdmToken')
}
